<template>
  <div class="ma-4 px-4">
    <v-row>
      <v-col cols="12">
        <v-sheet outlined>
          <v-data-table
            :headers="batchFilteredHeaders"
            :items="batches"
            fixed-header
            class="secondary row-height-50"
            hide-default-footer
          >
            <template #[`item.action`]="{ item }">
              <v-icon
                small
                class="mr-2"
                color="accent"
                :disabled="!item.active"
                @click="editBatch(item)"
              >
                mdi-pencil
              </v-icon>
            </template>
            <template #[`item.active_status`]="{ item }">
              <v-chip
                small
                :color="item.active ? 'green' : 'red'"
                dark
                @click="openConfirm('B', item)"
              >
                {{ item.active_status }}
              </v-chip>
            </template>
          </v-data-table>
        </v-sheet>
      </v-col>
    </v-row>
    <div class="pt-6">
      <span class="text-5xl font-weight-bold accent--text">
        APPLICATION SCHEDULE
      </span>
    </div>
    <searchBarFilter
      @add="create"
      @updateSearch="(v) => (searchSchedule = v)"
      class="mt-2"
    />
    <v-row>
      <v-col cols="12">
        <v-sheet outlined>
          <v-data-table
            :headers="headers"
            :search="searchSchedule"
            :items="programPartnerSchedules"
            fixed-header
            class="secondary row-height-50"
          >
            <template #[`item.action`]="{ item }">
              <v-icon
                :disabled="!item.active"
                small
                class="mr-2"
                color="accent"
                @click="editschedule(item)"
              >
                mdi-pencil
              </v-icon>
            </template>
            <template #[`item.active_status`]="{ item }">
              <v-chip
                small
                :color="item.active ? 'green' : 'red'"
                dark
                @click="openConfirm('P', item)"
              >
                {{ item.active_status }}
              </v-chip>
            </template>
          </v-data-table>
        </v-sheet>
      </v-col>
    </v-row>
    <div class="pt-6">
      <span class="text-5xl font-weight-bold accent--text"> COURSE FEE </span>
    </div>
    <searchBarFilter
      @add="createBatchCourseFee"
      @updateSearch="(v) => (searchFee = v)"
      class="mt-2"
    />
    <v-row>
      <v-col cols="12">
        <v-sheet outlined>
          <v-data-table
            :headers="programBatchCourseFeeHeaders"
            :search="searchFee"
            :items="programBatchCourseFees"
            fixed-header
            class="secondary row-height-50"
          >
            <template #[`item.action`]="{ item }">
              <v-icon
                small
                class="mr-2"
                color="accent"
                @click="editCourseFee(item)"
              >
                mdi-pencil
              </v-icon>
            </template>
            <template #[`item.course_fee`]="{ value }">
              {{ formatAmount(value) }}
            </template>
            <template #[`item.admission_fee`]="{ value }">
              {{ formatAmount(value) }}
            </template>
            <template #[`item.application_fee`]="{ value }">
              {{ formatAmount(value) }}
            </template>
            <template #[`item.advance_fee`]="{ value }">
              {{ formatAmount(value) }}
            </template>
            <template #[`item.exam_fee`]="{ value }">
              {{ formatAmount(value) }}
            </template>
            <template #[`item.arrear_fee`]="{ value }">
              {{ formatAmount(value) }}
            </template>
            <template #[`item.annual_upfront`]="{ value }">
              {{ formatAmount(value) }}
            </template>
            <template #[`item.full_upfront`]="{ value }">
              {{ formatAmount(value) }}
            </template>
            <template #[`item.pay_by_date`]="{ value }">
              {{ formatDate(value) }}
            </template>
            <template #[`item.active`]="{ item }">
              <v-chip
                small
                :color="item.active ? 'green' : 'red'"
                dark
                @click="openConfirm('P', item)"
              >
                {{ showActiveStatus(item) }}
              </v-chip>
            </template>
          </v-data-table>
        </v-sheet>
      </v-col>
    </v-row>
    <v-dialog v-model="scheduleDialog" width="850" persistent scrollable>
      <formDialog
        v-if="scheduleDialog"
        @closeDialog="scheduleDialog = false"
        @create="createProgramPartnerSchedule"
        @update="updateProgramPartnerSchedule"
        :data="schedule"
        :partners="partners"
        :edit="editScheduleMode"
        :viewPartner="viewPartner"
      />
    </v-dialog>
    <v-dialog v-model="batchDialog" width="800" persistent scrollable>
      <batchFormDialog
        v-if="batchDialog"
        @closeDialog="batchDialog = false"
        @update="updateBatch"
        :batch="batch"
        :programs="programs"
        :edit="editBatchMode"
      />
    </v-dialog>
    <v-dialog v-model="courseFeeDialog" width="1000" persistent scrollable>
      <formCourseFeeDialog
        v-if="courseFeeDialog"
        @closeDialog="courseFeeDialog = false"
        @create="createProgramBatchCourseFee"
        @update="updateProgramBatchCourseFee"
        :batchCourseFee="courseFee"
        :partners="partners"
        :programs="programs"
        :program_id="batches[0].program_id"
        :edit="editCourseFeeMode"
      />
    </v-dialog>
    <ConfirmDialog
      v-if="showDialog"
      :show="showDialog"
      @delete="changeConfirmation"
      @close="showDialog = false"
      :title="key === 'B' ? 'batch' : 'application schedule'"
      :name="
        key === 'B'
          ? currentItem.year + '-' + currentItem.batch
          : currentItem.name
      "
      :active="currentItem.active"
    />
  </div>
</template>

<script>
import formDialog from "@/components/programParnerSchedule/form.vue";
import formCourseFeeDialog from "@/components/batches/courseFee.vue";
import batchFormDialog from "@/components/batch/form.vue";
import searchBarFilter from "@/components/searchBarFilter.vue";
import ConfirmDialog from "@/components/confirm.vue";

import {
  partnerAdmssionScheduleHeaders,
  batchHeaders,
  programBatchCourseFeeHeaders,
} from "@/constants/headers";

export default {
  components: {
    formDialog,
    formCourseFeeDialog,
    batchFormDialog,
    searchBarFilter,
    ConfirmDialog,
  },
  props: {
    partnerId: {
      type: Number,
      default: () => 0,
    },
    itemsPerPage: {
      type: Number,
      default: () => 0,
    },
    partners: {
      type: Array,
      default: () => [],
    },
    programs: {
      type: Array,
      default: () => [],
    },
    programPartnerSchedules: {
      type: Array,
      default: () => [],
    },
    viewPartner: {
      type: Boolean,
      default: () => false,
    },
    batch_id: {
      type: Number,
      default: () => 0,
    },
    programBatchCourseFees: {
      type: Array,
      default: () => [],
    },
    batches: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      scheduleDialog: false,
      batchDialog: false,
      courseFeeDialog: false,
      editScheduleMode: false,
      editBatchMode: false,
      editCourseFeeMode: false,
      schedule: {},
      batch: {},
      courseFee: {},
      currentItem: {},
      showDialog: false,
      searchFee: "",
      searchSchedule: "",
      searchBatch: null,
      searchYear: null,
      headers: partnerAdmssionScheduleHeaders,
      batchFilteredHeaders: [],
      batchHeaders,
      programBatchCourseFeeHeaders: programBatchCourseFeeHeaders,
      key: "",
    };
  },
  watch: {},
  computed: {},
  created() {
    if (this.viewPartner)
      this.headers = this.headers.filter((item) => item.value !== "partner_id");

    this.batchFilteredHeaders = this.batchHeaders.filter(
      (item) => item.value !== "set_term",
    );
  },
  methods: {
    async initialise() {
      this.$emit("getProgramCourseFee");
      this.$emit("getBatches");
      this.$emit("getPrgPartnerSchedule");
    },
    async createProgramPartnerSchedule(schedule) {
      schedule.program_batch_id = this.batch_id;
      await this.$axios
        .post("batch_partner_schedules", { batch_partner_schedule: schedule })
        .then(() => {
          this.$store.commit("showSnackbar", {
            message: "Partner created successfully",
            color: "success",
          });
          this.resetValues();
          this.initialise();
        })
        .catch(async (error) => {
          const errorMessage = await this.$store.dispatch(
            "throwError",
            error.response,
          );
          this.$store.commit("showSnackbar", {
            message: errorMessage,
            color: "error",
          });
        });
    },
    async updateProgramPartnerSchedule(schedule) {
      await this.$axios
        .put("batch_partner_schedules/" + schedule.id, {
          batch_partner_schedule: schedule,
        })
        .then(() => {
          this.$store.commit("showSnackbar", {
            message: "Partner updated successfully",
            color: "success",
          });
          this.resetValues();
          this.initialise();
        })
        .catch(async (error) => {
          const errorMessage = await this.$store.dispatch(
            "throwError",
            error.response,
          );
          this.$store.commit("showSnackbar", {
            message: errorMessage,
            color: "error",
          });
        });
    },
    async createProgramBatchCourseFee(courseFee) {
      courseFee.program_batch_id = this.batch_id;
      await this.$axios
        .post("batch_partner_course_fees", {
          batch_partner_course_fee: courseFee,
        })
        .then(() => {
          this.$store.commit("showSnackbar", {
            message: "Batch course fee created successfully",
            color: "success",
          });
          this.resetValues();
          this.initialise();
        })
        .catch(async (error) => {
          const errorMessage = await this.$store.dispatch(
            "throwError",
            error.response,
          );
          this.$store.commit("showSnackbar", {
            message: errorMessage,
            color: "error",
          });
        });
    },
    async updateProgramBatchCourseFee(courseFee) {
      await this.$axios
        .put("batch_partner_course_fees/" + courseFee.id, {
          batch_partner_course_fee: courseFee,
        })
        .then(() => {
          this.$store.commit("showSnackbar", {
            message: "Batch course fee updated successfully",
            color: "success",
          });
          this.resetValues();
          this.initialise();
        })
        .catch(async (error) => {
          const errorMessage = await this.$store.dispatch(
            "throwError",
            error.response,
          );
          this.$store.commit("showSnackbar", {
            message: errorMessage,
            color: "error",
          });
        });
    },
    async updateBatch(batch) {
      await this.$axios
        .put("program_batches/" + batch.id, { program_batch: batch })
        .then(() => {
          this.$store.commit("showSnackbar", {
            message: "Batch updated successfully",
            color: "success",
          });
          this.resetValues();
          this.initialise();
        })
        .catch(async (error) => {
          const errorMessage = await this.$store.dispatch(
            "throwError",
            error.response,
          );
          this.$store.commit("showSnackbar", {
            message: errorMessage,
            color: "error",
          });
        });
    },
    changeConfirmation() {
      if (this.key == "B") {
        this.updateBatch({
          id: this.currentItem.id,
          active: !this.currentItem.active,
        });
      } else {
        this.updateProgramPartnerSchedule({
          id: this.currentItem.id,
          active: !this.currentItem.active,
        });
      }
    },
    openConfirm(key, item) {
      this.key = key;
      this.showDialog = true;
      this.currentItem = { ...item };
    },
    create() {
      this.schedule = { partner_id: this.partnerId };
      this.editScheduleMode = false;
      this.scheduleDialog = true;
    },
    createBatchCourseFee() {
      this.editCourseFeeMode = false;
      this.courseFeeDialog = true;
    },
    formatAmount(value) {
      return new Intl.NumberFormat("en-IN", {
        style: "currency",
        currency: "INR",
        maximumFractionDigits: 0,
      }).format(value);
    },
    resetValues() {
      this.editScheduleMode = false;
      this.scheduleDialog = false;
      this.showDialog = false;
      this.schedule = {};
      this.currentItem = {};
      this.editBatchMode = false;
      this.batchDialog = false;
      this.batch = {};
      this.editCourseFeeMode = false;
      this.courseFeeDialog = false;
      this.courseFee = {};
    },
    editschedule(item) {
      this.schedule = { ...item };
      this.editScheduleMode = true;
      this.scheduleDialog = true;
    },
    editBatch(item) {
      this.batch = { ...item };
      this.editBatchMode = true;
      this.batchDialog = true;
    },
    editCourseFee(item) {
      this.courseFee = { ...item };
      this.editCourseFeeMode = true;
      this.courseFeeDialog = true;
    },
    formatDate(date) {
      if (!date) return "";
      const [year, month, day] = date.split("-");
      return `${day}-${month}-${year}`;
    },
  },
};
</script>

<style></style>
